import api from './api';

// User Services
export const userService = {
  // Get all users with pagination
  getUsers: async (params = {}) => {
    const response = await api.get('/users', { params });
    return response.data;
  },

  // Get user by ID
  getUserById: async (id) => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  // Create new user
  createUser: async (userData) => {
    const response = await api.post('/users', userData);
    return response.data;
  },

  // Update user status
  updateUserStatus: async (id, status) => {
    const response = await api.patch(`/users/${id}/status`, { status });
    return response.data;
  },

  // Delete user
  deleteUser: async (id) => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },

  // Update current user's profile
  updateProfile: async (profileData) => {
    const response = await api.patch('/users/profile', profileData);
    return response.data;
  },

  // Change current user's password
  changePassword: async (passwordData) => {
    const response = await api.patch('/users/password', passwordData);
    return response.data;
  }
};
